import owd from 'owd/owd';
import _ from 'underscore';

export default class Marquee extends owd.Component {
	init() {
        this.buildMarquee();
        this.bind();
	}

    buildMarquee() {

        this.item = this.$element.find('span');

        let width = this.item.outerWidth();
        let windowWidth = this.dom.$window.width();
        let amount = Math.ceil(windowWidth / width);
        let html = '<span>'+this.item.html()+'</span>';

        for (let i = 0; i < amount; i++) {
            html += this.item.html();
        }

        this.$element.width(width);
        this.$element.html(html);

    }

	bind() {

        this.on('resize-x', this.dom.$window, _.debounce((e) => {
            this.buildMarquee();
        }, 100));

    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('marquee', {
    component: Marquee
});
